import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/highlights")({
  component: lazyRouteComponent(() => import("./-pages/admin.highlights")),
  head: () => ({
    meta: [{ title: "Home Highlights · Lecmo Admin" }, { name: "robots", content: "noindex" }],
  }),
});
